<script>
import { nextTick } from 'vue'

import Table from '../common/SortedCheckboxTable.vue'

export default {
    name: 'SelectionForm',
    
    components: {
        Table
    },

    props: {
        headers: {
            type: Array,
            default: () => []
        },
        rows: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        },
        type: {
            type: Number,
            default: -1
        }
    },

    emits: ['form-closed'],

    data() {
        return {
            rowsToEdit: this.rows
        }
    },

    async mounted() {
        await nextTick()
        document.getElementById('form').focus()
    },

    methods: {
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }
        },
        closeForm() {
            this.$emit('form-closed', this.type, this.rowsToEdit)
        },
        dataChanged(data) {
            this.rowsToEdit = data
        }
    }
}
</script>

<template>
    <div class="form table-form">
        <div id="form" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ title }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="form-wrapper">
                <div class="form-content rows gap-10">                    
                    <div class="scrollable">
                        <Table :headers="headers" :rows="rows" @data-changed="dataChanged" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>